import { request } from "./request";

export function insertRegister(username, password, role) {
  return request({
    url: '/register/insertRegister',
    params: { username, password, role }
  })
}


export function insertUser(registerId, username, password, createdUser) {
  return request({
    url: '/register/insertUser',
    params: { registerId, username, password, createdUser }
  })
}


export function queryRegister(startIndex, length) {
  return request({
    url: '/register/queryRegister',
    params: { startIndex, length }
  })
}


export function totalRegister() {
  return request({
    url: '/register/totalRegister',
  })
}


export function deleteRegister(id) {
  return request({
    url: '/register/deleteRegister',
    params: {id}
  })
}